import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
//
// Dynamic Cards
//
import { RtiAprCardModule } from '../rti-apr-card/rti-apr-card.module';
import { RtiCashCardModule } from '../rti-cash-card/rti-cash-card.module';
import { RtiDiscountCardModule } from '../rti-discount-card/rti-discount-card.module';
import { RtiLeaseCardModule } from '../rti-lease-card/rti-lease-card.module';
import { RtiLocalSpecialCard } from './rti-local-special-card';
//
// Directives
//
import { RtiDirectiveModule } from '../../../directive/rti-directive.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    RtiDirectiveModule,
    RtiAprCardModule,
    RtiCashCardModule,
    RtiDiscountCardModule,
    RtiLeaseCardModule
  ],
  declarations: [
    RtiLocalSpecialCard
  ],
  exports: [
    RtiLocalSpecialCard
  ]
})

export class RtiLocalSpecialCardModule {
}
